// Local storage key for the show details preference
const SHOW_DETAILS_KEY = 'activity_feed_show_details_preference';
// Default preference is collapsed (hide details)
export const DEFAULT_SHOW_DETAILS_PREFERENCE = 'collapsed';
/**
 * Get the show details preference from local storage
 * @returns The stored preference or the default if not found
 */
export function getShowDetailsPreference() {
    try {
        const storedPreference = localStorage.getItem(SHOW_DETAILS_KEY);
        if (storedPreference === 'expanded' || storedPreference === 'collapsed') {
            return storedPreference;
        }
        return DEFAULT_SHOW_DETAILS_PREFERENCE;
    }
    catch (error) {
        // In case of any issues with local storage (e.g., private browsing mode)
        console.error('Error accessing local storage:', error);
        return DEFAULT_SHOW_DETAILS_PREFERENCE;
    }
}
/**
 * Save the show details preference to local storage
 * @param preference - The preference to save ('expanded' or 'collapsed')
 * @returns True if saved successfully, false otherwise
 */
export function saveShowDetailsPreference(preference) {
    try {
        localStorage.setItem(SHOW_DETAILS_KEY, preference);
        return true;
    }
    catch (error) {
        console.error('Error saving to local storage:', error);
        return false;
    }
}
